<template lang="pug">
#print
  section.banner.position-relative
    div.picture
        img.img-fluid.big(src="img/banner/banner_print.jpg" alt="banner-certificate")
        img.img-fluid.small(src="img/banner/banner_print_mobile.jpg" alt="banner-certificate")
    div.mask_banner
    div.breadcrumb_block
      b-container
        b-breadcrumb(:items="breadcrumb_items")
    div.banner_h1
      h1 印刷
  b-container.py-0.py-lg-5.slogan
    p.text-center.font-weight-bolder.py-5 本製品可經印刷、上光、貼合或沖裁等工序製成各種印刷產品。
  section#product_profile
    b-row.menu
      b-col.text-center.position-relative(:class="{ active: p_show[0].show }" @click='change("PVC")') PVC
      b-col.text-center(:class="{ active: p_show[1].show }" @click='change("APET")') APET
    b-container.pt-md-4
      b-row#pvc_detail.detail.pb-5.py-md-5(:class="{ active: p_show[0].show }" @click='change("PVC")') 
        b-col(cols="12" md="8" order="2" order-md="1")
          div
            h3 
              span 產品特點
            p 1.本製品經特殊表面處理，紋路細膩，適合印刷加工，可供製成撲克牌。
              br
              |2. 因具有耐曲折、高耐衝擊性及貼合性佳等特性，可經印刷、貼合等加工，製成信用卡、識別卡、掛號卡等精美卡片。
              br
              |3.本製品亦能經真空成型加工，製作立體廣告、立體標示板等。
          div
            h3 
              span 產品特性
            ol
              li(v-for="item in p_feature" :key="item.message") {{ item.message }}
          div
            h3 
              span 產品用途
            ol
              li(v-for="item in p_use" :key="item.message") {{ item.message }}
        b-col.align-self-center.text-center(cols="12" md="4" order="1" order-md="2")
          swiper.swiper.swiper_product_img(:options="swiperOption_product_img")
            swiper-slide(v-for="item in product_img_data" :key="item.id")
              b-img.w-100(:src="item.img_src",:alt="item.img_alt",:title="item.img_alt" )
            div.swiper-pagination(slot="pagination")
      b-row#apet_detail.detail.pb-5.py-md-5(:class="{ active: p_show[1].show }" @click='change("APET")') 
        b-col(cols="12" md="8" order="2" order-md="1")
          div
            h3 
              span 產品特點
            p 本製品具有優良之透明外觀及優異之抗靜電性，膠布印刷時發送性優良且著墨性佳，膠布本身爽身性佳故具有良好的抗擦傷效果，適用於UV平版或網版印刷之製品(如：足球卡、炫風卡、收集卡及化妝品等)。	
          div
            h3 
              span 產品特性
            ol
              li(v-for="item in a_feature" :key="item.message") {{ item.message }}
          div
            h3 
              span 產品用途
            ol
              li(v-for="item in a_use" :key="item.message") {{ item.message }}
        b-col.align-self-center.text-center.pb-5.pb-md-0(cols="12" md="4" order="1" order-md="2")
          swiper.swiper.swiper_product_img(:options="swiperOption_product_img")
            swiper-slide(v-for="item in product_img_data" :key="item.id")
              b-img.w-100(:src="item.img_src",:alt="item.img_alt",:title="item.img_alt" )
            div.swiper-pagination(slot="pagination")
  section#specification.py-5(:class="{ active: p_show[0].show }" @click='change("PVC")') 
    div.mask
    h2.text-center 
      span PVC 產品規格
    b-container(fluid)
      swiper.swiper.py-5(:options="swiperOption_pvc").swiper_pvc.swiper_product_col_3
        swiper-slide(v-for="item in p_specification" :key="item.id")
          ul
            li 
              span {{ item.name }}
            li 
              span {{ item.feature }}
            li 
              span {{ item.outward }}
            li 
              span(v-html="item.thickness")
            li 
              span(v-html="item.proportion")
            li 
              span(v-html="item.pull")
            li 
              span(v-html="item.elongation")
            li 
              span(v-html="item.heating")
            li 
              span(v-html="item.vcm")
        <div class="swiper-pagination" slot="pagination"></div>
  section#specification.py-5(:class="{ active: p_show[1].show }" @click='change("APET")') 
    div.mask
    h2.text-center 
      span  APET 產品規格
    b-container(fluid)
      swiper.swiper.py-5(:options="swiperOption_apet").swiper_apet.swiper_product_col_2
        swiper-slide(v-for="item in a_specification" :key="item.id")
          ul
              li 
                span {{ item.name }}
              li 
                span {{ item.feature }}
              li 
                span {{ item.outward }}
              li 
                span(v-html="item.thickness")
              li 
                span(v-html="item.proportion")
              li 
                span(v-html="item.transmittance")
              li 
                span(v-html="item.gloss")
              li 
                span(v-html="item.mist")
        <div class="swiper-pagination" slot="pagination"></div>
  section#others.py-5 
    b-container
      h3 其他應用
      swiper.swiper.py-5(:options="swiperOption")
        swiper-slide(v-for="item in swiperdata" :key="item.id")
          div
            router-link(:to="item.href_link")
              div
                b-img.w-100(:src="item.url" fluid)
                h5 {{item.name}}
              p.py-4 {{item.text}}
              svg.o_arrow_r(viewbox="0 0 50 30")
                line(x1=0 y1=20 x2=45 y2=20)
                line(x1=45 y1=20 x2=31 y2=8)
        div.swiper-pagination(slot="pagination")
        div.swiper-button-prev(slot="button-prev")
          svg(width="65px" height="65px" viewBox="0 0 65 65" style="transform: scale( 1.75) rotate(180deg)")
            g(id="desktop" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd")
              g(id="product" transform="translate(-1250.000000, -2680.000000)" stroke="#979797")
                  g(id="arrow" transform="translate(1282.500000, 2710.500000) rotate(-180.000000) translate(-1282.500000, -2710.500000) translate(1255.000000, 2683.000000)")
                    circle(stroke-width="1.1" fill="#FFFFFF" cx="27.3493151" cy="27.3493151" r="27.3493151")
                    polyline(stroke-width="3.3" stroke-linecap="round" stroke-linejoin="round" fill="none" points="29.0068493 19.0616438 20.7191781 27.3493151 29.0068493 35.6369863")
        div.swiper-button-next(slot="button-next")
          svg(width="65px" height="65px" viewBox="0 0 65 65" style="transform: scale( 1.75)")
            g(id="desktop" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd")
              g(id="product" transform="translate(-1250.000000, -2680.000000)" stroke="#979797")
                  g(id="arrow" transform="translate(1282.500000, 2710.500000) rotate(-180.000000) translate(-1282.500000, -2710.500000) translate(1255.000000, 2683.000000)")
                    circle(stroke-width="1.1" fill="#FFFFFF" cx="27.3493151" cy="27.3493151" r="27.3493151")
                    polyline(stroke-width="3.3" stroke-linecap="round" stroke-linejoin="round" fill="none" points="29.0068493 19.0616438 20.7191781 27.3493151 29.0068493 35.6369863")
        

</template>
<script>
export default {
    metaInfo: {
        title: 'PVC / APET印刷-南亞硬質膠布',
        titleTemplate: '',
        meta: [
            { name: 'description', content: 'PVC硬質膠布具有耐曲折、高耐衝擊性及貼合性佳等特性，可經印刷、貼合等加工，製成信用卡、識別卡及撲克牌等精美卡片。有一般印刷用、撲克牌用、合成紙用等。APET膠布具有優良之透明外觀及優異之抗靜電性，膠布印刷時發送性優良且著墨性佳，適用於UV平版或網版印刷之製品。有一般印刷用、平版印刷用等。' },
            { name: 'Keywords', content: '南亞塑膠、硬質膠布、PVC、APET、印刷、撲克牌、合成紙。' },
            { name: 'og:title', content: 'PVC / APET印刷-南亞硬質膠布' },
            { name: 'og:type', content: 'website' },
            { name: 'og:url', content: 'https://www.nan-ya-pvc.com.tw/' },
            { name: 'og:description', content: 'PVC硬質膠布具有耐曲折、高耐衝擊性及貼合性佳等特性，可經印刷、貼合等加工，製成信用卡、識別卡及撲克牌等精美卡片。有一般印刷用、撲克牌用、合成紙用等。APET膠布具有優良之透明外觀及優異之抗靜電性，膠布印刷時發送性優良且著墨性佳，適用於UV平版或網版印刷之製品。有一般印刷用、平版印刷用等。' },
            { name: 'og:image', content: 'https://www.nan-ya-pvc.com.tw/img/OGimage.jpg' },
        ],
    },
  data() {
      return {
        breadcrumb_items: [
          {
            text: 'Home',
            to: { name: 'App' }
          },
          {
            text: '印刷',
            active: true
          }
        ],
        swiperOption_product_img: {
          slidesPerView: 1,
          pagination: {
            el: '.swiper-pagination',
            clickable: true
          }
        },
        product_img_data: [
          { 
            id: '1',
            img_src: 'img/processing_Desktop/print_img_01.jpg',
            img_alt: '南亞硬質PVC耐曲折、高耐衝擊性及貼合性佳、可經印刷、貼合製成卡片、撲克牌，APET透明、抗靜電性，可經印刷製成卡片。' },
          { 
            id: '2',
            img_src: 'img/processing_Desktop/print_img_02.jpg',
            img_alt: '南亞硬質PVC耐曲折、高耐衝擊性及貼合性佳、可經印刷、貼合製成卡片、撲克牌，APET透明、抗靜電性，可經印刷製成卡片。' },
          { 
            id: '3',
            img_src: 'img/processing_Desktop/print_img_03.jpg',
            img_alt: '南亞硬質PVC耐曲折、高耐衝擊性及貼合性佳、可經印刷、貼合製成卡片、撲克牌，APET透明、抗靜電性，可經印刷製成卡片。' }
        ],
        p_show: [
          {show: true},
          {show: false}
        ],
        p_feature: [
          { message: '貼合性、展平性及印刷性佳。' },
          { message: '符合歐盟REACH、ROHS規範要求。' },
        ],
        p_use: [
          { message: '可客製化項目：電暈、耐寒、耐溫、耐候、耐燃、抗靜電及防霧等。' },
          { message: '檢驗規範：ASTM D-1593、ASTM D-792、JIS-K6734等。' }
        ],
        a_feature: [
          { message: '透明度佳。' },
          { message: '抗靜電性佳。' },
          { message: '印刷著墨性佳。' },
          { message: '爽身性佳，抗擦傷效果良好。' }
        ],
        a_use: [
          { message: '可客製化項目：爽身、電暈、耐寒、抗靜電、防霧及高週波等。' },
          { message: '檢驗規範：ASTM D-1593、ASTM D-792、ASTM D-1003及ASTM D-523等。' }
        ],
        p_specification: [
          { 
            id: '1',
            name: '一般印刷VPPG',
            feature: '特色: 印刷性、貼合性佳',
            outward: '外觀: 透明、有色、亮面、霧面',
            thickness: '參考厚度<sub>(mm)</sub>：0.25',
            proportion: '比重<sub>(g/cm3)</sub>：1.37±3%',
            pull: '拉力強度<sub>(kg/cm2)</sub>:<br/><span class="pl-5">MD>450/CD>400</span>',
            elongation: '伸長率<sub>(%)</sub>：<br/><span class="pl-5">MD>80/CD>80</span>',
            heating: '加熱收縮<sub>(%,150°CX10分)</sub>：<br/><span class="pl-5">MD-6~-13/CD<3.5</span>',
            vcm: 'VCM含量<sub>(ppm)</sub>：未管制' },
          { 
            id: '2',
            name: '撲克牌VPPP',
            feature: '特色: 印刷性、貼合性佳',
            outward: '外觀: 透明、有色、亮面、霧面',
            thickness: '參考厚度<sub>(mm)</sub> ：0.27',
            proportion: '比重<sub>(g/cm3)</sub> ：1.49±3%',
            pull: '拉力強度<sub>(kg/cm2)</sub>：<br/><span class="pl-5">MD>450/CD>400</span>',
            elongation: '伸長率<sub>(%)</sub> ：<br/><span class="pl-5">MD>135/CD>90</span>',
            heating: '加熱收縮<sub>(%,150°CX10分)</sub>：<br/><span class="pl-5">MD-4~-11/CD<2</span>',
            vcm: 'VCM含量(ppm)</sub>：未管制' },
          { 
            id: '3',
            name: '印刷成型VPPS',
            feature: '特色: 印刷性、成型性良好',
            outward: '外觀: 透明、有色、亮面、霧面',
            thickness: '參考厚度<sub>(mm)</sub> ：0.20 ',
            proportion: '比重<sub>(g/cm3)</sub> ：1.37±3%',
            pull: '拉力強度<sub>(kg/cm2)</sub>：<br/> <span class="pl-5">MD>450/CD>400</span>',
            elongation: '伸長率<sub>(%)</sub>：<br/> <span class="pl-5">MD>90/CD>35</span>',
            heating: '加熱收縮<sub>(%,150°CX10分)</sub>：<br/> <span class="pl-5">MD-6~-9/CD<1</span>',
            vcm: 'VCM含量<sub>(ppm)</sub>：未管制' }
        ],
        a_specification: [
          { 
            id: '1',
            name: '一般印刷用APPG',
            feature: '特色: 透明度佳、展平性、印刷性良好',
            outward: '外觀: 透明、有色',
            thickness: '參考厚度<sub>(mm)</sub>：0.30',
            proportion: '比重<sub>(g/cm3)</sub>：1.34±0.01',
            transmittance: '透光度<sub>(透明製品,%)</sub>:<br/><span class="pl-5">88～92</span>',
            gloss: '光澤度<sub>(透明製品)</sub>：<br/><span class="pl-5">155～165</span>',
            mist: '霞霧度<sub>(%)</sub>：<br/><span class="pl-5">≦2.0</span>'},
          { 
            id: '2',
            name: '平版印刷用APPS ',
            feature: '特色: 印刷性良好、著墨性佳',
            outward: '外觀: 透明、有色',
            thickness: '參考厚度<sub>(mm)</sub> ：0.30',
            proportion: '比重<sub>(g/cm3)</sub> ：1.34±0.01',
            transmittance: '透光度<sub>(透明製品,%)</sub>：<br/><span class="pl-5">88～92</span>',
            gloss: '光澤度<sub>(透明製品)</sub> ：<br/><span class="pl-5">150～165</span>',
            mist: '霞霧度<sub>(%)</sub>：<br/><span class="pl-5">≦4.5</span>' }
        ],
        swiperOption_pvc: {
          slidesPerView: 3,
          spaceBetween: 30,
          breakpoints: {
            1170: {
              spaceBetween: 30,
              slidesPerView: 'auto',
            },
            991: {
              spaceBetween: 30,
              slidesPerView: 'auto',
              pagination: {
                el: '.swiper-pagination',
                clickable: true
              }
            },
            410: {
              spaceBetween: 10,
              slidesPerView: 'auto',
              pagination: {
                el: '.swiper-pagination',
                clickable: true
              }
            }
          }
        },
        swiperOption_apet: {
          slidesPerView: 2,
          spaceBetween: 30,
          breakpoints: {
            790: {
              spaceBetween: 30,
              slidesPerView: 'auto',
              pagination: {
                el: '.swiper-pagination',
                clickable: true
              }
            },
            410: {
              spaceBetween: 10,
              slidesPerView: 'auto',
              pagination: {
                el: '.swiper-pagination',
                clickable: true
              }
            }
          }
        },
        swiperOption: {
          slidesPerView: 3,
          spaceBetween: 51,
          loop: true,
          pagination: {
            el: '.swiper-pagination',
            clickable: true
          },
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev'
          },
          breakpoints: {
            1024: {
              slidesPerView: 2,
              spaceBetween: 50
            },
            767: {
              slidesPerView: 1,
              spaceBetween: 50
            }
          }
        },
        swiperdata: [
          {
            id:'1',
            name:'真空成型',
            text:'採用吸塑設備，利用高溫及模具，將平面的塑膠片，成型出立體包裝曲面殼，以讓消費者可直接透視產品並保護之。',
            url:'./img/processing_Desktop/other_pic_pro_1.jpg',
            href_link: 'vacuum_forming'
          },
          {
            id:'2',
            name:'摺疊成型',
            text:'將完成印刷、上光、模切等加工的盒片半成品，依盒體的成型要求將盒片上膠、折疊、黏合成型，製作成可用於包裝使用的盒體。',
            url:'./img/processing_Desktop/other_pic_pro_2.jpg',
            href_link: 'folding_forming'
          },
          {
            id:'3',
            name:'熱封',
            text:'使用介質加熱法將要用高週波熔接的塑膠產品放在兩片金屬板中間，高週波電壓被連接到這兩塊電極，通電後分子在高週波電場內開始振盪加熱，到達...',
            url:'./img/processing_Desktop/other_pic_pro_3.jpg',
            href_link: 'heat_seal'
          },
          {
            id:'5',
            name:'電鍍',
            text:'在真空條件下，通過蒸餾或濺射等方式在膠布表面沉積金屬薄膜，通過這樣的方式可以得到非常薄的表面鍍層，同時具有速度快附著力好的突出優點。',
            url:'./img/processing_Desktop/other_pic_pro_5.jpg',
            href_link: 'plating'
          }
        ]
      }
    },
  methods: {
    change:function(item) {
      if(item === 'PVC'){
        this.p_show[0].show = true
        this.p_show[1].show = false
      }
      else{
        this.p_show[1].show = true
        this.p_show[0].show = false
      }
      // for(let i in this.p_show){
      //   this.p_show[i].show = !this.p_show[i].show
      // }
      // this.p_show[0].show = false
      // this.p_show[1].show = true
      // this.p_show = !this.p_show
      // for(let i=0; i<this.p_show.length; i++){
      //   this.p_show[i] = !this.p_show[i]
      //   console.log(i)
      // }
      // console.log(this.p_show[1] + "," + this.p_show[0])
      }
      // if(event){
      //   this.p_show[0] = true
      //   this.p_show[1] = true
      //   console.log(this.p_show[1])}
    // }
  },
}
</script>
<style lang="sass">
@import '@/css/product.sass'
#print
  #specification
    background-image: url(../assets/bg/bg_print.jpg)


</style>
